import { combineReducers } from 'redux';
import { CheckinOrderFragment } from '@websky/graphql';
import { orderReducer } from './order/reducers';
import { selectedServicesReducer, SelectedServicesState } from './selectedServices/reducers';
import servicesSavingReducer from './servicesLoading/reducer';
import { SeatMapState } from '../../../SeatMap/store/types';
import { seatMapReducer } from '../../../SeatMap/store/reducers';
import { ErrorState } from '@entities/error/model/types';
import { errorReducer } from '@entities/error';
import { RestrictionsState, restrictionsReducer } from '@entities/restrictions';
import { orderReducer as newOrderReducer, OrderState as NewOrderState } from '@entities/order';

export interface CheckinState {
	order: CheckinOrderFragment;
	newOrder: NewOrderState;
	selectedServices: SelectedServicesState;
	servicesLoading: boolean;
	seatMap: SeatMapState;
	restrictions: RestrictionsState;
	error?: ErrorState;
}

export const rootReducer = combineReducers<CheckinState>({
	order: orderReducer,
	newOrder: newOrderReducer,
	selectedServices: selectedServicesReducer,
	servicesLoading: servicesSavingReducer,
	seatMap: seatMapReducer,
	restrictions: restrictionsReducer,
	error: errorReducer
});
